import React from 'react'
import useModal from '@hooks/useModal'
import { FieldValues, useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import 'twin.macro'
import MessageModal from '@components/shared/MessageModal'

const TosContent = {
  이용약관: {
    placeholder:
      '네이버 서비스 및 제품(이하 ‘서비스’)을 이용해 주셔서 감사합니다.본 약관은 다양한 네이버 서비스의 이용과 관련하여 네이버 서비스를제공하는 네이버 주식회사(이하 ‘네이버’)와 이를 이용하는 네이버서비스 회원(이하 ‘회원’) 또는 비회원과의 관계를 설명하며, 아울러여러분의 네이버 서비스 이용에 도움이 될 수 있는 유익한 정보를 포함하고 있습니다.',
    fieldname: 'terms1',
    require: true,
  },
  '개인정보수집 및 이용안내': {
    placeholder:
      '네이버 서비스 및 제품(이하 ‘서비스’)을 이용해 주셔서 감사합니다.본 약관은 다양한 네이버 서비스의 이용과 관련하여 네이버 서비스를제공하는 네이버 주식회사(이하 ‘네이버’)와 이를 이용하는 네이버서비스 회원(이하 ‘회원’) 또는 비회원과의 관계를 설명하며, 아울러여러분의 네이버 서비스 이용에 도움이 될 수 있는 유익한 정보를 포함하고 있습니다.',
    fieldname: 'terms2',
    require: true,
  },
  '개인정보의 제 3자 제공 동의 안내': {
    placeholder:
      '네이버 서비스 및 제품(이하 ‘서비스’)을 이용해 주셔서 감사합니다.본 약관은 다양한 네이버 서비스의 이용과 관련하여 네이버 서비스를제공하는 네이버 주식회사(이하 ‘네이버’)와 이를 이용하는 네이버서비스 회원(이하 ‘회원’) 또는 비회원과의 관계를 설명하며, 아울러여러분의 네이버 서비스 이용에 도움이 될 수 있는 유익한 정보를 포함하고 있습니다.',
    fieldname: 'terms3',
    require: true,
  },
  '마케팅 활용방침 및 수신 동의': {
    placeholder:
      '네이버 서비스 및 제품(이하 ‘서비스’)을 이용해 주셔서 감사합니다.본 약관은 다양한 네이버 서비스의 이용과 관련하여 네이버 서비스를제공하는 네이버 주식회사(이하 ‘네이버’)와 이를 이용하는 네이버서비스 회원(이하 ‘회원’) 또는 비회원과의 관계를 설명하며, 아울러여러분의 네이버 서비스 이용에 도움이 될 수 있는 유익한 정보를 포함하고 있습니다.',
    fieldname: 'terms4',
    require: false,
  },
}

const TOS = () => {
  const { register, handleSubmit, setValue } = useForm()
  const [openResModal] = useModal()
  const navigate = useNavigate()

  const handleAllAgree = () => {
    Object.entries(TosContent).forEach(([_, value]) => {
      const { fieldname } = value
      setValue(fieldname, 'true')
    })
  }

  const handleTOS = (formData: FieldValues) => {
    const { terms4: opptionalTerms } = formData
    navigate(`/signup?optionalterms=${opptionalTerms}`)
  }

  const handleInvalidTos = () => {
    openResModal(
      <MessageModal>
        필수항목 동의 및 마케팅 수신항목 선택이 필요합니다.
      </MessageModal>
    )
  }

  return (
    <section className="pb-10 w-600">
      <form onSubmit={handleSubmit(handleTOS, handleInvalidTos)}>
        <div className="mb-10 text-2xl font-bold flex-center ">약관동의</div>
        <div className="flex flex-col w-full gap-12 mb-10">
          {Object.entries(TosContent).map(([key, value]) => {
            const { placeholder, fieldname, require } = value
            return (
              <div tw="w-full flex flex-col gap-12" key={key}>
                <label>
                  {key}{' '}
                  {require ? (
                    <span tw="text-purple-600">{`( 필수 )`}</span>
                  ) : (
                    <span tw="text-blue-600">{`( 선택 )`}</span>
                  )}
                </label>
                <textarea
                  tw="flex h-120 p-10 w-full resize-none focus:border-neutral-400 text-[15px] overflow-hidden"
                  className="input"
                  disabled
                  placeholder={placeholder}
                />
                <div className="flex items-center gap-16 text-base py-15 h-15 all:cursor-pointer">
                  <div tw="flex gap-8 items-center">
                    <input
                      {...register(fieldname, {
                        required: true,
                        validate: (value) =>
                          require ? value === 'true' : true,
                      })}
                      name={fieldname}
                      id={`${fieldname}-agree`}
                      type="radio"
                      value="true"
                    />
                    <label htmlFor={`${fieldname}-agree`} tw="mt-2">
                      동의합니다
                    </label>
                  </div>
                  <div tw="flex gap-8 items-center">
                    <input
                      {...register(fieldname)}
                      name={fieldname}
                      id={`${fieldname}-decline`}
                      type="radio"
                      value="false"
                    />
                    <label htmlFor={`${fieldname}-decline`} tw="mt-2">
                      동의하지 않습니다
                    </label>
                  </div>
                </div>
              </div>
            )
          })}
          <div tw="w-full flex text-base border-2 py-20 px-15 mt-15">
            <div tw="flex items-center">
              이용약관 개인정보 수집이용, 알림메일 수신여부에 모두 동의합니다.
            </div>
            <button
              type="button"
              tw="ml-auto"
              className="button base"
              onClick={handleAllAgree}
            >
              전체 동의
            </button>
          </div>
        </div>
        <div tw="w-full flex mt-15 mb-40 gap-28">
          <Link tw="w-full" to="/">
            <button tw="w-full" className="button base">
              취소
            </button>
          </Link>
          <button tw="w-full" className="button base">
            확인
          </button>
        </div>
      </form>
    </section>
  )
}

export default TOS
